import 'react-toastify/dist/ReactToastify.css'; // Import toastify styles

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import AdminDashboard from './pages/Dashboard/admin-dashboard';
import LoginPage from './pages/Login/login-page';
import React from 'react';
import { ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <div>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path='/admin/dashboard' element={<AdminDashboard />} />
          <Route path='/' element={<LoginPage />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
